// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonSettingsUpdate_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.3923 3.07347C4.63523 4.08791 3.40857 5.66824 2.8096 7.45134L.463467 8.80588C.829008 5.79019 2.55898 2.97723 5.3923 1.34142 10.1752-1.42001 16.2911.218743 19.0526 5.00167L20.7846 4.00167 20.1865 8.96577 15.5885 7.00167 17.3205 6.00167C15.1114 2.17533 10.2186.864327 6.3923 3.07347ZM1.73206 15.0017C3.03564 17.2595 5.08676 18.8167 7.3923 19.5411V17.4182C5.79454 16.7732 4.3924 15.6095 3.4641 14.0017L5.19615 13.0017.598076 11.0376 0 16.0017 1.73206 15.0017Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.9756 10H15.809L15.3916 11.2522C14.5261 11.4018 13.726 11.7421 13.0361 12.2283L11.855 11.6378L11.0301 12.4627L11.6206 13.6438C11.1344 14.3337 10.7941 15.1338 10.6445 15.9993L9.3923 16.4167V17.5833L10.6445 18.0007C10.7941 18.8662 11.1344 19.6663 11.6206 20.3562L11.0301 21.5372L11.855 22.3622L13.036 21.7717C13.726 22.2579 14.5261 22.5982 15.3916 22.7478L15.809 24H16.9756L17.393 22.7478C18.2585 22.5982 19.0586 22.2579 19.7485 21.7717L20.9296 22.3622L21.7545 21.5373L21.164 20.3562C21.6502 19.6663 21.9905 18.8662 22.1401 18.0007L23.3923 17.5833V16.4167L22.1401 15.9993C21.9905 15.1338 21.6502 14.3337 21.164 13.6437L21.7545 12.4627L20.9296 11.6378L19.7485 12.2283C19.0586 11.7421 18.2585 11.4018 17.393 11.2522L16.9756 10ZM20.3923 17C20.3923 19.2091 18.6014 21 16.3923 21C14.1832 21 12.3923 19.2091 12.3923 17C12.3923 14.7909 14.1832 13 16.3923 13C18.6014 13 20.3923 14.7909 20.3923 17Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonSettingsUpdate is a generated icon component.
 */
let IconCommonSettingsUpdate = IconCommonSettingsUpdate_1 = class IconCommonSettingsUpdate extends IconBaseElement {
    render() {
        return html `${IconCommonSettingsUpdate_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonSettingsUpdate.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonSettingsUpdate = IconCommonSettingsUpdate_1 = __decorate([
    customElement('zui-icon-common-settings-update')
], IconCommonSettingsUpdate);
export { IconCommonSettingsUpdate };
